<template>
	<div class="">
	  <div class="integral_con pr text-center">
      <div class="fw-500 c7 fz-38 mb-10">{{integral}}</div>
      <div class="fw-500 c7 fz-13">剩余积分</div>
			<div class="c7 fz-15 guize" @click="$router.push('/integralrule')">
				<span class="iconfont icon-wenhao "></span>
				<span class="ml-5">积分规则</span>
			</div>

      <div class="list_every plr-15 box-s inter_main_con maxh">
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="finishedtext"
					@load="initData"
					offset="17"
				>
					<div class="flexs c1 flex-jus h71 bb-E every_inter" v-for="(item, index) in list" :key="index">
						<div class="text-left">
							<div class="fz-15 fw-500 mb-10 text-hide w277">{{item.title}}</div>
							<div class="fz-13">{{item.date}}</div>
						</div>
						<div class="fz-15 fw-500 c0" :class="{ c8: item.record.substring(0,1) == '-' }">{{item.record}}</div>
					</div>
				</van-list>
        
			</div>
		</div>
		<noData v-if="show"></noData>
    <load :loadFlag="loadFlag" style="top: 55%"></load>
	</div>
</template>
<script>
	import load from "@/components/loading"
  import { userIntegral } from '@/api/api.js'
	import {getList} from "@/utils/common.js";
	import noData from "@/components/noData"
	export default {
		components: {
			load,
			noData
		},
		data() {
			return {
				list: [],
				integral: 0,//积分
				// list: [],
				loading: false,
				finished: false,
				page: 1,
				show: false,
				finishedtext: '',
				loadFlag: false,
				show: false
			};
		},
		created() {
		},
		methods: {
			initData(){
				getList(this, userIntegral,  { page: this.page }, 'intergral', 7 )

			}
		}
	}
</script>
<style lang="less" scoped>
.integral_con {
	padding-top: 30px;
	box-sizing: border-box;
  width: 100%;
	height: 155px;
	background: url('../../assets/img/bg/my_fen_bg.png') no-repeat;
	background-size: 100%;
}

.inter_main_con {
	position: absolute;
	left: 16px;
	right: 16px;
	top: 120px;
}

.guize {
	position: absolute;
	top: 15px;
	right: 16px;
}

.maxh {
	height: calc(100vh - 17px - 120px);
	overflow: auto;
}
.maxh::-webkit-scrollbar{
	display: none;
}



.every_inter:last-child {
	border-bottom: none;
}

/deep/.van-list__loading {
	display: none;
}
</style>
